const industries = [
    { key: 168820001, value: 'Accounting' },
    { key: 168820002, value: 'Agriculture' },
    { key: 168820003, value: 'Aged Care' },
    { key: 168820004, value: 'Apparel' },
    { key: 168820005, value: 'Banking and Finance' },
    { key: 168820006, value: 'Community Services' },
    { key: 168820007, value: 'Construction' },
    { key: 168820008, value: 'Customer Services' },
    { key: 168820009, value: 'Design' },
    { key: 168820010, value: 'Energy' },
    { key: 168820011, value: 'Education' },
    { key: 168820012, value: 'Engineering' },
    { key: 168820013, value: 'Food and Beverages' },
    { key: 168820014, value: 'Government' },
    { key: 168820015, value: 'Healthcare' },
    { key: 168820016, value: 'Hospitality' },
    { key: 168820017, value: 'Human Resources' },
    { key: 168820018, value: 'Information and Communication Technology' },
    { key: 168820019, value: 'Insurance' },
    { key: 168820020, value: 'Legal' },
    { key: 168820021, value: 'Media and Advertising' },
    { key: 168820022, value: 'Manufacturing' },
    { key: 168820023, value: 'Not for Profit' },
    { key: 168820024, value: 'Real Estate' },
    { key: 168820025, value: 'Retail' },
    { key: 168820026, value: 'Sales' },
    { key: 168820027, value: 'Science and Technology' },
    { key: 168820028, value: 'Security' },
    { key: 168820029, value: 'Tourism' },
    { key: 168820030, value: 'Trades and Services' },
    { key: 168820031, value: 'Transportation' },
    { key: 168820032, value: 'Utilities' },
    { key: 168820033, value: 'Other' }
];

export default industries;